var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg6 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 101",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "6")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-.5,50.5A50.5,50.5,0,1,0,50,0,50.5,50.5,0,0,0-.5,50.5Zm89.5,0a39,39,0,1,1-39-39A39,39,0,0,1,89,50.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M48.21,20.73V50.32a1.57,1.57,0,1,0,3.14,0V20.73a1.57,1.57,0,1,0-3.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.27,61.77c-.8.33-1.4.73-1.33.88s.77,0,1.56-.33L49.82,50.95c.8-.33,1.4-.73,1.33-.88s-.76,0-1.56.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M50.53,48.24a2.3,2.3,0,1,0,0,4.59h19.4a2.3,2.3,0,1,0,0-4.59Z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 50.24,
    cy: 50.24,
    r: 3.91
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg6, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/6.42ff88dd.svg";
export { ForwardRef as ReactComponent };